<div class="border-dashed p-2 h-custom mx-2 ">
    <aerp-base-schema-form *ngIf="model && layout" (onSubmitResponse)="onSubmitResponse($event)" [model]="model" [dataModel]="dataModel" [dataProcessor]="dataProcessor.bind(this)" [layout]="layout"></aerp-base-schema-form>
</div>